var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1000px",
    height: "336px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1045.13 351.64",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M474.51 139.33l-24.63 0 0 -112.9 67.67 0 0 19.61 -43.04 0 0 29.09 40.06 0 0 19.61 -40.06 0 0 44.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    fill: "white",
    fillRule: "nonzero",
    d: "M540.61 139.33l0 -112.9 25.01 0 0 93.14 47.89 0 0 19.76 -72.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    fill: "white",
    fillRule: "nonzero",
    d: "M730.07 26.43l0 73.08c0,8.33 -1.95,15.66 -5.84,21.93 -3.91,6.3 -9.53,11.09 -16.91,14.44 -7.39,3.35 -16.09,5.03 -26.18,5.03 -15.15,0 -26.94,-3.71 -35.34,-11.17 -8.41,-7.43 -12.59,-17.6 -12.59,-30.54l0 -72.77 24.93 0 0 69.13c0,8.72 1.84,15.1 5.48,19.16 3.66,4.08 9.73,6.11 18.18,6.11 8.19,0 14.11,-2.05 17.8,-6.14 3.69,-4.08 5.54,-10.51 5.54,-19.26l0 -69 24.93 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    fill: "white",
    fillRule: "nonzero",
    d: "M828.65 108.02c0,10.2 -3.86,18.21 -11.52,24.09 -7.66,5.88 -18.35,8.8 -32.01,8.8 -12.59,0 -23.75,-2.26 -33.42,-6.8l0 -22.24c7.96,3.4 14.71,5.8 20.22,7.2 5.51,1.39 10.55,2.08 15.13,2.08 5.51,0 9.72,-1 12.64,-3.01 2.95,-2 4.41,-5 4.41,-8.96 0,-2.21 -0.63,-4.19 -1.93,-5.9 -1.29,-1.74 -3.19,-3.4 -5.7,-4.98 -2.51,-1.61 -7.61,-4.16 -15.29,-7.64 -7.22,-3.27 -12.65,-6.38 -16.26,-9.36 -3.61,-2.98 -6.47,-6.45 -8.62,-10.43 -2.18,-3.96 -3.25,-8.6 -3.25,-13.89 0,-9.99 3.55,-17.84 10.63,-23.56 7.08,-5.72 16.86,-8.57 29.34,-8.57 6.15,0 11.99,0.69 17.58,2.08 5.57,1.4 11.38,3.35 17.47,5.88l-8.07 18.61c-6.31,-2.48 -11.52,-4.19 -15.62,-5.17 -4.14,-0.97 -8.19,-1.47 -12.15,-1.47 -4.74,0 -8.38,1.05 -10.91,3.16 -2.54,2.11 -3.81,4.87 -3.81,8.27 0,2.11 0.53,3.96 1.55,5.51 1.02,1.58 2.64,3.08 4.87,4.56 2.23,1.48 7.52,4.11 15.87,7.91 11.05,5.06 18.6,10.12 22.7,15.18 4.08,5.08 6.15,11.27 6.15,18.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    fill: "white",
    fillRule: "nonzero",
    d: "M919.7 108.02c0,10.2 -3.86,18.21 -11.51,24.09 -7.66,5.88 -18.35,8.8 -32.02,8.8 -12.59,0 -23.75,-2.26 -33.42,-6.8l0 -22.24c7.96,3.4 14.72,5.8 20.23,7.2 5.51,1.39 10.55,2.08 15.12,2.08 5.51,0 9.73,-1 12.65,-3.01 2.94,-2 4.4,-5 4.4,-8.96 0,-2.21 -0.63,-4.19 -1.92,-5.9 -1.3,-1.74 -3.2,-3.4 -5.71,-4.98 -2.5,-1.61 -7.6,-4.16 -15.29,-7.64 -7.22,-3.27 -12.64,-6.38 -16.25,-9.36 -3.61,-2.98 -6.48,-6.45 -8.63,-10.43 -2.17,-3.96 -3.25,-8.6 -3.25,-13.89 0,-9.99 3.56,-17.84 10.64,-23.56 7.08,-5.72 16.86,-8.57 29.34,-8.57 6.14,0 11.98,0.69 17.58,2.08 5.56,1.4 11.37,3.35 17.46,5.88l-8.07 18.61c-6.31,-2.48 -11.52,-4.19 -15.62,-5.17 -4.13,-0.97 -8.18,-1.47 -12.15,-1.47 -4.74,0 -8.38,1.05 -10.91,3.16 -2.53,2.11 -3.8,4.87 -3.8,8.27 0,2.11 0.52,3.96 1.54,5.51 1.02,1.58 2.65,3.08 4.88,4.56 2.23,1.48 7.52,4.11 15.87,7.91 11.04,5.06 18.59,10.12 22.7,15.18 4.07,5.08 6.14,11.27 6.14,18.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    fill: "white",
    fillRule: "nonzero",
    d: "M1037.12 26.43l0 73.08c0,8.33 -1.96,15.66 -5.84,21.93 -3.91,6.3 -9.53,11.09 -16.92,14.44 -7.38,3.35 -16.09,5.03 -26.17,5.03 -15.15,0 -26.94,-3.71 -35.35,-11.17 -8.4,-7.43 -12.59,-17.6 -12.59,-30.54l0 -72.77 24.94 0 0 69.13c0,8.72 1.84,15.1 5.48,19.16 3.66,4.08 9.72,6.11 18.18,6.11 8.18,0 14.11,-2.05 17.8,-6.14 3.69,-4.08 5.54,-10.51 5.54,-19.26l0 -69 24.93 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    fill: "white",
    fillRule: "nonzero",
    d: "M517.85 296.39l-67.97 0 0 -112.89 67.97 0 0 19.6 -42.95 0 0 24.83 39.95 0 0 19.61 -39.95 0 0 29.09 42.95 0 0 19.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    fill: "white",
    fillRule: "nonzero",
    d: "M640.31 238.86c0,18.58 -5.51,32.82 -16.56,42.7 -11.07,9.88 -27.02,14.83 -47.91,14.83l-33.39 0 0 -112.89 37.03 0c19.26,0 34.22,4.87 44.88,14.6 10.64,9.72 15.95,23.32 15.95,40.76zm-25.98 0.61c0,-24.24 -11.18,-36.37 -33.55,-36.37l-13.31 0 0 73.53 10.74 0c24.08,0 36.12,-12.39 36.12,-37.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    fill: "white",
    fillRule: "nonzero",
    d: "M664.81 296.39l0 -112.89 25.01 0 0 112.89 -25.01 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 9,
    fill: "white",
    fillRule: "nonzero",
    d: "M765.03 296.39l-25.01 0 0 -92.97 -32.04 0 0 -19.92 89.09 0 0 19.92 -32.04 0 0 92.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 10,
    fill: "white",
    fillRule: "nonzero",
    d: "M922.37 239.81c0,18.71 -4.82,33.08 -14.52,43.12 -9.69,10.04 -23.58,15.05 -41.65,15.05 -18.07,0 -31.96,-5.01 -41.66,-15.05 -9.7,-10.04 -14.52,-24.46 -14.52,-43.25 0,-18.79 4.85,-33.15 14.58,-43.06 9.69,-9.91 23.64,-14.86 41.76,-14.86 18.13,0 32.02,4.98 41.6,14.97 9.62,9.98 14.41,24.35 14.41,43.08zm-86.12 0c0,12.63 2.51,22.11 7.49,28.52 5.02,6.38 12.51,9.56 22.46,9.56 19.97,0 29.95,-12.7 29.95,-38.08 0,-25.43 -9.92,-38.13 -29.79,-38.13 -9.97,0 -17.46,3.22 -22.53,9.62 -5.04,6.4 -7.58,15.92 -7.58,28.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 11,
    fill: "white",
    fillRule: "nonzero",
    d: "M971.83 233.62l8.07 0c7.91,0 13.75,-1.26 17.49,-3.79 3.78,-2.51 5.65,-6.49 5.65,-11.89 0,-5.35 -1.93,-9.17 -5.76,-11.44 -3.85,-2.26 -9.81,-3.4 -17.88,-3.4l-7.57 0 0 30.52zm0 19.45l0 43.32 -25.02 0 0 -112.89 34.38 0c16.04,0 27.88,2.79 35.57,8.38 7.71,5.58 11.54,14.07 11.54,25.43 0,6.64 -1.9,12.54 -5.73,17.73 -3.8,5.17 -9.2,9.23 -16.2,12.15 17.75,25.38 29.32,41.8 34.69,49.2l-27.77 0 -28.16 -43.32 -13.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 12,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M474.51 139.33l-24.63 0 0 -112.9 67.67 0 0 19.61 -43.04 0 0 29.09 40.06 0 0 19.61 -40.06 0 0 44.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 13,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M540.61 139.33l0 -112.9 25.01 0 0 93.14 47.89 0 0 19.76 -72.9 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 14,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M730.07 26.43l0 73.08c0,8.33 -1.95,15.66 -5.84,21.93 -3.91,6.3 -9.53,11.09 -16.91,14.44 -7.39,3.35 -16.09,5.03 -26.18,5.03 -15.15,0 -26.94,-3.71 -35.34,-11.17 -8.41,-7.43 -12.59,-17.6 -12.59,-30.54l0 -72.77 24.93 0 0 69.13c0,8.72 1.84,15.1 5.48,19.16 3.66,4.08 9.73,6.11 18.18,6.11 8.19,0 14.11,-2.05 17.8,-6.14 3.69,-4.08 5.54,-10.51 5.54,-19.26l0 -69 24.93 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 15,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M828.65 108.02c0,10.2 -3.86,18.21 -11.52,24.09 -7.66,5.88 -18.35,8.8 -32.01,8.8 -12.59,0 -23.75,-2.26 -33.42,-6.8l0 -22.24c7.96,3.4 14.71,5.8 20.22,7.2 5.51,1.39 10.55,2.08 15.13,2.08 5.51,0 9.72,-1 12.64,-3.01 2.95,-2 4.41,-5 4.41,-8.96 0,-2.21 -0.63,-4.19 -1.93,-5.9 -1.29,-1.74 -3.19,-3.4 -5.7,-4.98 -2.51,-1.61 -7.61,-4.16 -15.29,-7.64 -7.22,-3.27 -12.65,-6.38 -16.26,-9.36 -3.61,-2.98 -6.47,-6.45 -8.62,-10.43 -2.18,-3.96 -3.25,-8.6 -3.25,-13.89 0,-9.99 3.55,-17.84 10.63,-23.56 7.08,-5.72 16.86,-8.57 29.34,-8.57 6.15,0 11.99,0.69 17.58,2.08 5.57,1.4 11.38,3.35 17.47,5.88l-8.07 18.61c-6.31,-2.48 -11.52,-4.19 -15.62,-5.17 -4.14,-0.97 -8.19,-1.47 -12.15,-1.47 -4.74,0 -8.38,1.05 -10.91,3.16 -2.54,2.11 -3.81,4.87 -3.81,8.27 0,2.11 0.53,3.96 1.55,5.51 1.02,1.58 2.64,3.08 4.87,4.56 2.23,1.48 7.52,4.11 15.87,7.91 11.05,5.06 18.6,10.12 22.7,15.18 4.08,5.08 6.15,11.27 6.15,18.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 16,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M919.7 108.02c0,10.2 -3.86,18.21 -11.51,24.09 -7.66,5.88 -18.35,8.8 -32.02,8.8 -12.59,0 -23.75,-2.26 -33.42,-6.8l0 -22.24c7.96,3.4 14.72,5.8 20.23,7.2 5.51,1.39 10.55,2.08 15.12,2.08 5.51,0 9.73,-1 12.65,-3.01 2.94,-2 4.4,-5 4.4,-8.96 0,-2.21 -0.63,-4.19 -1.92,-5.9 -1.3,-1.74 -3.2,-3.4 -5.71,-4.98 -2.5,-1.61 -7.6,-4.16 -15.29,-7.64 -7.22,-3.27 -12.64,-6.38 -16.25,-9.36 -3.61,-2.98 -6.48,-6.45 -8.63,-10.43 -2.17,-3.96 -3.25,-8.6 -3.25,-13.89 0,-9.99 3.56,-17.84 10.64,-23.56 7.08,-5.72 16.86,-8.57 29.34,-8.57 6.14,0 11.98,0.69 17.58,2.08 5.56,1.4 11.37,3.35 17.46,5.88l-8.07 18.61c-6.31,-2.48 -11.52,-4.19 -15.62,-5.17 -4.13,-0.97 -8.18,-1.47 -12.15,-1.47 -4.74,0 -8.38,1.05 -10.91,3.16 -2.53,2.11 -3.8,4.87 -3.8,8.27 0,2.11 0.52,3.96 1.54,5.51 1.02,1.58 2.65,3.08 4.88,4.56 2.23,1.48 7.52,4.11 15.87,7.91 11.04,5.06 18.59,10.12 22.7,15.18 4.07,5.08 6.14,11.27 6.14,18.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 17,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M1037.12 26.43l0 73.08c0,8.33 -1.96,15.66 -5.84,21.93 -3.91,6.3 -9.53,11.09 -16.92,14.44 -7.38,3.35 -16.09,5.03 -26.17,5.03 -15.15,0 -26.94,-3.71 -35.35,-11.17 -8.4,-7.43 -12.59,-17.6 -12.59,-30.54l0 -72.77 24.94 0 0 69.13c0,8.72 1.84,15.1 5.48,19.16 3.66,4.08 9.72,6.11 18.18,6.11 8.18,0 14.11,-2.05 17.8,-6.14 3.69,-4.08 5.54,-10.51 5.54,-19.26l0 -69 24.93 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 18,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M517.85 296.39l-67.97 0 0 -112.89 67.97 0 0 19.6 -42.95 0 0 24.83 39.95 0 0 19.61 -39.95 0 0 29.09 42.95 0 0 19.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 19,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M640.31 238.86c0,18.58 -5.51,32.82 -16.56,42.7 -11.07,9.88 -27.02,14.83 -47.91,14.83l-33.39 0 0 -112.89 37.03 0c19.26,0 34.22,4.87 44.88,14.6 10.64,9.72 15.95,23.32 15.95,40.76zm-25.98 0.61c0,-24.24 -11.18,-36.37 -33.55,-36.37l-13.31 0 0 73.53 10.74 0c24.08,0 36.12,-12.39 36.12,-37.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 20,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M664.81 296.39l0 -112.89 25.01 0 0 112.89 -25.01 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 21,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M765.03 296.39l-25.01 0 0 -92.97 -32.04 0 0 -19.92 89.09 0 0 19.92 -32.04 0 0 92.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 22,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M922.37 239.81c0,18.71 -4.82,33.08 -14.52,43.12 -9.69,10.04 -23.58,15.05 -41.65,15.05 -18.07,0 -31.96,-5.01 -41.66,-15.05 -9.7,-10.04 -14.52,-24.46 -14.52,-43.25 0,-18.79 4.85,-33.15 14.58,-43.06 9.69,-9.91 23.64,-14.86 41.76,-14.86 18.13,0 32.02,4.98 41.6,14.97 9.62,9.98 14.41,24.35 14.41,43.08zm-86.12 0c0,12.63 2.51,22.11 7.49,28.52 5.02,6.38 12.51,9.56 22.46,9.56 19.97,0 29.95,-12.7 29.95,-38.08 0,-25.43 -9.92,-38.13 -29.79,-38.13 -9.97,0 -17.46,3.22 -22.53,9.62 -5.04,6.4 -7.58,15.92 -7.58,28.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 23,
    fill: "none",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: 8.13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M971.83 233.62l8.07 0c7.91,0 13.75,-1.26 17.49,-3.79 3.78,-2.51 5.65,-6.49 5.65,-11.89 0,-5.35 -1.93,-9.17 -5.76,-11.44 -3.85,-2.26 -9.81,-3.4 -17.88,-3.4l-7.57 0 0 30.52zm0 19.45l0 43.32 -25.02 0 0 -112.89 34.38 0c16.04,0 27.88,2.79 35.57,8.38 7.71,5.58 11.54,14.07 11.54,25.43 0,6.64 -1.9,12.54 -5.73,17.73 -3.8,5.17 -9.2,9.23 -16.2,12.15 17.75,25.38 29.32,41.8 34.69,49.2l-27.77 0 -28.16 -43.32 -13.3 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1_0"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_1Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AE4D",
    fillRule: "nonzero",
    stroke: "#FEFEFE",
    strokeWidth: 11.62,
    strokeMiterlimit: 22.9256,
    d: "M315.72 5.81l-209.21 0c-55.39,0 -100.7,45.31 -100.7,100.7l0 107.99c0,37.59 20.89,70.52 51.62,87.82l0.96 40.54c0.06,2.26 2.46,3.67 4.46,2.62l57.64 -30.28 195.23 0c55.39,0 100.7,-45.31 100.7,-100.7l0 -107.99c0,-55.39 -45.31,-100.7 -100.7,-100.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\xD0A1\\xD0BB\\xD0BE\\xD0B9_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_2Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#277A59",
    fillRule: "nonzero",
    d: "M231.44 177.22l-0.98 0 0.98 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2454983688368"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#277A59",
    fillRule: "nonzero",
    d: "M220.05 167.25l-0.97 0 0.97 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#277A59",
    fillRule: "nonzero",
    d: "M220.05 167.25l-0.97 0 0.97 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#277A59",
    fillRule: "nonzero",
    d: "M220.05 167.25l-0.97 0 0.97 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    stroke: "#FEFEFE",
    strokeWidth: 11.62,
    strokeMiterlimit: 22.9256,
    d: "M340.63 200.19l0 0c0,21.42 -17.36,38.78 -38.78,38.78l-180.72 0c-21.42,0 -38.78,-17.36 -38.78,-38.78l0 -77.97c0,-21.42 17.36,-38.78 38.78,-38.78l180.72 0c21.42,0 38.78,17.36 38.78,38.78l0 77.97z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2454983690384"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#06805E",
    fillRule: "nonzero",
    d: "M213.75 101.04l-86.17 0c-14.66,0 -26.53,11.73 -26.53,26.19 0,14.46 11.87,26.18 26.53,26.18l86.17 0c14.65,0 26.53,-11.72 26.53,-26.18 0,-14.46 -11.88,-26.19 -26.53,-26.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06805E",
    fillRule: "nonzero",
    d: "M143.4 168.43c-0.15,0 -0.72,0.1 -0.74,0.81l-0.01 8.89c0,1.24 1.01,2.25 2.24,2.25l1.43 0c1.58,0 2.67,1.6 2.08,3.08l-10.65 26.61c-0.75,1.88 -3.41,1.88 -4.16,0l-10.65 -26.61c-0.59,-1.48 0.5,-3.08 2.09,-3.08l1.42 0c1.24,0 2.24,-1.01 2.24,-2.25l0 -8.96c-0.01,-0.47 -0.33,-0.74 -0.78,-0.74 -13.72,0 -25.11,10.19 -26.3,23.85 -1.35,15.52 10.85,28.54 26.09,28.54l16.1 0c14.62,0 26.45,-11.99 26.18,-26.68 -0.26,-14.42 -12.16,-25.71 -26.58,-25.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06805E",
    fillRule: "nonzero",
    d: "M295 168.76l-86.18 0c-11.89,0 -21.93,7.73 -25.3,18.37 -0.13,0.4 0.19,0.82 0.61,0.82l9.92 0c1.24,0 2.24,-1 2.24,-2.24l0 -1.43c0,-1.58 1.6,-2.67 3.08,-2.08l26.61 10.65c1.88,0.75 1.88,3.41 0,4.16l-26.61 10.65c-1.48,0.59 -3.08,-0.5 -3.08,-2.08l0 -1.43c0,-1.24 -1,-2.24 -2.24,-2.24l-9.68 0c-0.55,0 -0.95,0.54 -0.78,1.05 3.43,10.53 13.42,18.16 25.23,18.16l86.18 0c14.65,0 26.52,-11.72 26.52,-26.18 0,-14.46 -11.87,-26.18 -26.52,-26.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06805E",
    fillRule: "nonzero",
    d: "M294.63 101.76l-15.23 0c-14.42,0 -26.79,11.28 -27.06,25.7 -0.26,14.68 11.56,26.68 26.19,26.68l1.02 -0.02c0.32,-0.02 0.56,-0.02 0.59,-0.6l0.02 -8.55c0,-1.24 -1.01,-2.24 -2.25,-2.24l-1.42 0c-1.59,0 -2.67,-1.61 -2.08,-3.08l10.64 -26.61c0.76,-1.88 3.42,-1.88 4.17,0l10.65 26.61c0.58,1.47 -0.5,3.08 -2.09,3.08l-1.42 0c-1.24,0 -2.24,1 -2.24,2.24l0 8.79c0,0.21 0.17,0.38 0.38,0.38 11.93,0 22.64,-7.95 25.5,-19.54 4.27,-17.34 -8.74,-32.84 -25.37,-32.84z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.beff596da1016b49ef44bca13eb05805.svg";
export { ForwardRef as ReactComponent };